import PropTypes from 'prop-types';
import React from 'react';
import { BASE_URL } from '../../const';
import classes from './style.module.scss';

export default function CompanyAdress({ addressDatas, externalLogos }) {
  return (
    <div className={classes.addressContainer}>
      <a href={BASE_URL} target="_blank" rel="noopener noreferrer">
        <img src={addressDatas.logoUrl} width="150px" alt="Bitexen Logo" />
      </a>
      <div className={classes.companyName}>{addressDatas.title}</div>
      <div
        className={classes.address}
        dangerouslySetInnerHTML={{ __html: addressDatas.description }}
      />
      <div className={classes.externalLogoContainer}>
        {externalLogos.map(({ url, logoUrl }) => (
          <a href={url} key={url} rel="noopener noreferrer" target="_blank">
            <img src={logoUrl} className={classes.externalLogo} alt={url} />
          </a>
        ))}
      </div>
    </div>
  );
}

CompanyAdress.propTypes = {
  addressDatas: PropTypes.objectOf(PropTypes.any).isRequired,
  externalLogos: PropTypes.arrayOf(PropTypes.any).isRequired
};
